function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function decimalParts(value) {
  var raw = String(value !== null && value !== void 0 ? value : '').trim();
  if (!/^\d+(\.\d+)?$/.test(raw)) {
    return null;
  }
  var _raw$split = raw.split('.'),
    _raw$split2 = _slicedToArray(_raw$split, 2),
    whole = _raw$split2[0],
    _raw$split2$ = _raw$split2[1],
    fraction = _raw$split2$ === void 0 ? '' : _raw$split2$;
  return {
    whole: whole,
    fraction: fraction
  };
}

/**
 * Unit amount times a whole quantity, in decimal strings.
 * Same digit arithmetic as the payment-address quantity scaling.
 * A quantity of 0 is 0. An unparseable amount is empty.
 */
function multiplyDecimalAmount(amount, quantity) {
  var parts = decimalParts(amount);
  var qty = Math.floor(Number(quantity));
  if (!parts || !Number.isFinite(qty) || qty < 0) {
    return '';
  }
  if (qty === 0) {
    return '0';
  }
  var digits = "".concat(parts.whole).concat(parts.fraction).replace(/^0+/, '') || '0';
  var product = (BigInt(digits) * BigInt(qty)).toString().padStart(parts.fraction.length + 1, '0');
  if (!parts.fraction.length) {
    return product.replace(/^0+(?=\d)/, '');
  }
  var cut = product.length - parts.fraction.length;
  var head = product.slice(0, cut).replace(/^0+(?=\d)/, '') || '0';
  var tail = product.slice(cut).replace(/0+$/, '');
  return tail ? "".concat(head, ".").concat(tail) : head;
}
function addDecimalAmounts(left, right) {
  var a = decimalParts(left);
  var b = decimalParts(right);
  if (!a) {
    return b ? String(right).trim() : '';
  }
  if (!b) {
    return String(left).trim();
  }
  var scale = Math.max(a.fraction.length, b.fraction.length);
  var leftInt = BigInt(a.whole + a.fraction.padEnd(scale, '0'));
  var rightInt = BigInt(b.whole + b.fraction.padEnd(scale, '0'));
  var sum = (leftInt + rightInt).toString().padStart(scale + 1, '0');
  if (!scale) {
    return sum.replace(/^0+(?=\d)/, '');
  }
  var cut = sum.length - scale;
  var head = sum.slice(0, cut).replace(/^0+(?=\d)/, '') || '0';
  var tail = sum.slice(cut).replace(/0+$/, '');
  return tail ? "".concat(head, ".").concat(tail) : head;
}
function web3SaleTicker() {
  var ticker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var symbol = String(ticker || '').trim().toUpperCase();
  if (!symbol || symbol === 'SAITO') {
    return '';
  }
  return symbol;
}
function decimalIsPositive(value) {
  var raw = String(value !== null && value !== void 0 ? value : '').trim();
  if (!/^\d+(\.\d+)?$/.test(raw)) {
    return false;
  }
  return /[1-9]/.test(raw);
}

/**
 * A canonical sale becomes eligible once `waitBlocks` Saito blocks have been
 * produced after its inclusion block. Anything else unprocessed stays pending.
 */
function classifyWeb3Proceeds() {
  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var latestBlockId = arguments.length > 1 ? arguments[1] : undefined;
  var waitBlocks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var wait = Math.max(0, Math.floor(Number(waitBlocks) || 0));
  var latest = Number(latestBlockId);
  var pending = {};
  var eligible = {};
  var _iterator = _createForOfIteratorHelper(rows || []),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var row = _step.value;
      var ticker = web3SaleTicker(row === null || row === void 0 ? void 0 : row.web3_ticker);
      var earned = multiplyDecimalAmount(row === null || row === void 0 ? void 0 : row.web3_amount, row === null || row === void 0 ? void 0 : row.quantity_sold);
      if (!ticker || !decimalIsPositive(earned)) {
        continue;
      }
      var soldBlock = Number(row === null || row === void 0 ? void 0 : row.block_id_sold);
      var canonical = Number(row === null || row === void 0 ? void 0 : row.longest_chain_sold) === 1;
      var matured = canonical && Number.isFinite(latest) && soldBlock > 0 && latest >= soldBlock + wait;
      var bucket = matured ? eligible : pending;
      bucket[ticker] = addDecimalAmounts(bucket[ticker] || '0', earned);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return {
    pending: pending,
    eligible: eligible
  };
}
module.exports = {
  multiplyDecimalAmount: multiplyDecimalAmount,
  addDecimalAmounts: addDecimalAmounts,
  web3SaleTicker: web3SaleTicker,
  decimalIsPositive: decimalIsPositive,
  classifyWeb3Proceeds: classifyWeb3Proceeds
};